import axios from "axios";

const instance = axios.create({
  // baseURL: "https://elearning0706.cybersoft.edu.vn/api",
  baseURL: "https://api.daneshpark.org",
  // baseURL: "http://localhost:2094",
});

export default instance;
